export const flushFormAction = () => ({
  type: 'FLUSH_CRIT_CREATE_FORM',
})

export const setFormElementAction = (element, value) => ({
  type: 'SET_CRIT_CREATE_FORM',
  element,
  value,
})
